const menuButton = document.querySelector(".menu-button")
const mobileMenuButton = document.querySelector(".mobile-menu-button")
const mobileMenu = document.querySelector(".mobile-menu")
const menu = document.querySelector(".menu")
const menuClose = document.querySelector(".menu-button-close")
const main = document.querySelector("main")



menuButton.addEventListener('click', function () {

    mobileMenu.classList.toggle("open")
    menu.classList.toggle("open")
    this.classList.toggle("move")


});

mobileMenuButton.addEventListener('click',  function () {
    mobileMenu.classList.toggle('open')
});

menuClose.addEventListener('click', function() {
    menu.classList.remove('open')
});

main.addEventListener('click', function() {
    menu.classList.remove("open")
    menuButton.classList.remove("move")

});

const closeBanner = document.querySelector('.close-widget')
const banner = document.querySelector('.widget')

closeBanner.addEventListener('click', function () {
    banner.classList.add("hidden")
});
